module.exports = __webpack_public_path__ + "static/media/ground-right.a3d7d2e2.webp";